<template>
  <section>
    <q-table
      style="height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      v-model:pagination="pagination"
      class="q-mt-md tabela-tamanho-fixo"
      color="primary"
      dense
      row-key="name"
      @request="handleRequest"
      :rows-per-page-label="'Linhas Por Página'"
      :rows-per-page-options="[10, 25, 50, 100]"
    >
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-autenticacao="props">
        <q-td>
          <q-img
            :src="props.row.capacitacao_auth_content"
            style="max-width: 60px; height: 60px"
            fit="contain"
          >
          </q-img>
        </q-td>
      </template>
      <template #body-cell-treinamento_data_realizacao="props">
        <q-td>
          <span v-if="props.row.treinamento_data_realizacao">{{
            props.row.treinamento_data_realizacao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-treinamento_data_expiracao="props">
        <q-td>
          <span v-if="props.row.treinamento_data_expiracao">{{
            props.row.treinamento_data_expiracao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-capacitacao_data_confirmacao="props">
        <q-td>
          <span v-if="props.row.capacitacao_data_confirmacao">{{
            props.row.capacitacao_data_confirmacao
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("/")
          }}</span>
          <span class="q-ml-sm" v-if="props.row.capacitacao_data_confirmacao">{{
            props.row.capacitacao_data_confirmacao.split(" ")[1]
          }}</span>
        </q-td>
      </template>
    </q-table>
  </section>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
const columns = [
  {
    name: "treinamento_nome",
    label: "Treinamento",
    field: "treinamento_nome",
    align: "left",
  },
  {
    name: "treinamento_data_realizacao",
    label: "Realização",
    field: "treinamento_data_realizacao",
    align: "left",
  },
  {
    name: "capacitacao_instrutor",
    label: "Instrutor",
    field: "capacitacao_instrutor",
    align: "left",
  },
  {
    name: "treinamento_data_expiracao",
    label: "Vencimento",
    field: "treinamento_data_expiracao",
    align: "left",
  },
  {
    name: "capacitacao_data_confirmacao",
    label: "Confirmação",
    field: "capacitacao_data_confirmacao",
    align: "left",
  },
  {
    name: "autenticacao",
    label: "Autenticação",
    field: "autenticacao",
    align: "left",
  },
];
export default {
  setup() {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      // rowsNumber: 15,
    });
    const rows = ref([]);
    const disable = ref(true);
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const filtrar = ref("");

    const id = route.params.id;

    const getTreinamentos = async (page = 0, rowsPerPage = 15) => {
      disable.value = true;

      try {
        let response = await store.dispatch("user/getTreinamentos", {
          id,
          page,
          treinamento: filtrar.value,
          per_page: rowsPerPage,
        });

        rows.value = response.data.data;

        pagination.value.page = response.data.current_page;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async (props) => {
      getTreinamentos(props.pagination.page, props.pagination.rowsPerPage);
    };

    onMounted(getTreinamentos);

    const removerGrupo = async (group_id) => {
      try {
        await store.dispatch("user/removerGrupo", {
          id,
          group_id,
        });

        quasar.notify({
          message: "Grupo removido com sucesoo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getTreinamentos();
      } catch (error) {
        quasar.notify({
          message: "Erro ao remover grupo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => filtrar.value,
      () => {
        getTreinamentos();
      }
    );

    return {
      columns,
      rows,
      pagination,
      disable,
      getTreinamentos,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      handleRequest,
      removerGrupo,
      filtrar,
    };
  },
};
</script>
